import React, { useState } from "react";
import AdminsApi from "~/admin/apis/admins.api";
import CompaniesApi from "~/admin/apis/companies.api";
import InfluencersApi from "~/admin/apis/influencers.api";
import PageDataLoader from "~/admin/components/PageDataLoader";
import TabBar from "~/admin/components/TabBar";
import useDataLoading from "~/admin/hooks/useDataLoading";
import useLayout from "~/hooks/useLayout";
import useMount from "~/hooks/useMount";
import AdminsTab from "./AdminsTab";
import CompaniesTab from "./CompaniesTab";
import InfluencersTab from "./InfluencersTab";

export default function UsersPage() {
  const { setLayout } = useLayout();
  const [activeTab, setActiveTab] = useState("influencers");
  const [influencers, setInfluencers] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [influencerSearchName, setInfluencerSearchName] = useState(null);
  const [companySearchName, setCompanySearchName] = useState(null);
  const [adminSearchName, setAdminSearchName] = useState(null);
  const dataLoading = useDataLoading();

  const tabItems = [
    {
      key: "influencers",
      title: "Influenceurs",
    },
    {
      key: "companies",
      title: "Entreprises",
    },
    {
      key: "admins",
      title: "administrateurs",
    },
  ];

  useMount(() => {
    setLayout({
      title: "Utilisateurs",
      activeMenuKeys: ["users"],
    });
    loadData();
  });

  const loadData = async (searchName = null, page = 1) => {
    dataLoading.start();
    setInfluencers([]);

    let error = null;
    const data = await Promise.all([
      InfluencersApi.paginateValid(searchName, page),
      CompaniesApi.paginateValid(searchName, page),
      AdminsApi.paginate(searchName, page),
    ]).catch((e) => {
      error = e;
      return null;
    });

    dataLoading.stop(error);

    if (data) {
      setInfluencers(data[0]);
      setCompanies(data[1]);
      setAdmins(data[2]);
    }
  };

  const changeTab = (key) => {
    switch (key) {
      default:
      case "influencers":
        searchInfluencer(null, 1);
        break;
      case "companies":
        searchInfluencer(null, 1);
        break;
      case "admins":
        searchInfluencer(null, 1);
        break;
    }
    setActiveTab(key);
  };

  const searchInfluencer = async (searchName, page = 1) => {
    setInfluencerSearchName(searchName);

    let influencers = await InfluencersApi.paginateValid(
      searchName,
      page
    ).catch((e) => {
      return null;
    });

    if (influencers) {
      setInfluencers(influencers);
    }
  };

  const onPaginateInfluencers = (page) => {
    searchInfluencer(influencerSearchName, page);
  };

  const searchCompanies = async (searchName, page = 1) => {
    setCompanySearchName(searchName);

    let companies = await CompaniesApi.paginateValid(searchName, page).catch(
      (e) => {
        return null;
      }
    );

    if (companies) {
      setCompanies(companies);
    }
  };

  const onPaginateCompanies = (page) => {
    searchCompanies(companySearchName, page);
  };

  const searchAdmins = async (searchName, page = 1) => {
    setAdminSearchName(searchName);

    let admins = await AdminsApi.paginate(searchName, page).catch((e) => {
      return null;
    });

    if (admins) {
      setAdmins(admins);
    }
  };

  const onPaginateAdmins = (page) => {
    searchAdmins(adminSearchName, page);
  };

  return (
    <PageDataLoader isLoading={dataLoading.isLoading}>
      <>
        <div className="w-full min-h-[60px] border-b-2 border-slate-700 flex justify-between items-center px-10">
          <TabBar
            items={tabItems}
            activeItem={activeTab}
            onChange={changeTab}
          />
          <div className="font-bold text-2xl">Utilisateurs</div>
        </div>
        <div className="p-6 overflow-auto">
          {activeTab === "influencers" && (
            <InfluencersTab
              influencers={influencers}
              onSearch={searchInfluencer}
              onPaginate={onPaginateInfluencers}
            />
          )}
          {activeTab === "companies" && (
            <CompaniesTab
              companies={companies}
              onSearch={searchCompanies}
              onPaginate={onPaginateCompanies}
            />
          )}
          {activeTab === "admins" && (
            <AdminsTab
              admins={admins}
              onSearch={searchAdmins}
              onPaginate={onPaginateAdmins}
            />
          )}
        </div>
      </>
    </PageDataLoader>
  );
}
